import React from 'react';
import { useNavigate } from 'react-router-dom';
import { trackEvent } from '../../utils/analytics';

const FeatureShowcase = ({
  title,
  copy = '',
  items = [],
  cta = false,
  ctaLabel = 'Preview Your Plan',
  onPrimaryCtaClick,
  ctaLocation = 'feature_showcase'
}) => {
  const navigate = useNavigate();
  return (
    <section className="text-center">
      <div className="max-w-6xl mx-auto px-2 sm:px-4">
        <div className="space-y-3">
          {title && (
            <h2 className="text-3xl md:text-4xl font-semibold">{title}</h2>
          )}
          {copy && (
            <p className="text-lg md:text-xl mb-2 max-w-3xl mx-auto leading-relaxed text-center text-white">
              {copy}
            </p>
          )}
        </div>

        <div className="mt-8 grid gap-6 md:grid-cols-3">
          {items.map((item) => (
            <article
              key={item.title}
              className="group glass-card rounded-lg border border-white/10 bg-white/5 p-6 transition-transform duration-300 ease-out hover:-translate-y-1 hover:bg-white/8"
            >
              <div className="relative mb-5 flex h-40 items-center justify-center overflow-hidden">
                {item.image ? (
                  <img
                    src={item.image.src}
                    alt={item.image.alt || ''}
                    loading="lazy"
                    className="h-full w-full object-contain"
                  />
                ) : item.illustration}
              </div>
              <h3 className="text-lg font-semibold text-white">{item.title}</h3>
              <p className="mt-2 text-sm text-white/80 leading-relaxed">{item.body}</p>
              {item.cta && (
                <ul className="mt-4 space-y-1 text-sm text-emerald-200/90">
                  {item.cta.map((ctaLine) => (
                    <li key={ctaLine}>• {ctaLine}</li>
                  ))}
                </ul>
              )}
            </article>
          ))}
        </div>

        {cta && (
          <div className="mt-8 flex justify-center">
            <button
              type="button"
              className="btn-primary-cta w-full sm:w-auto"
              onClick={() => {
                if (onPrimaryCtaClick) {
                  onPrimaryCtaClick(ctaLocation, ctaLabel);
                  return;
                }
                trackEvent('interview_started', 'conversion', 'what_you_get_cta');
                navigate('/interview/wizard');
              }}
            >
              {ctaLabel}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default FeatureShowcase;
